const variables = {
  cta: {
    variant: 'primary',
  },
};

export default variables;
